// Translator notes: Argument frames from the glosses (engine/src/en-frames.ts).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';
import { CASE_IN_FI, CASE_NAME_FI, CASE_IN_EN } from './words';

export const notes = defineNotes({
  framePrep: {
    args: ['word', 'prep', 'case', 'hv'],
    fi: (a: string[]) =>
      a[1]
        ? `Sanakirjan merkinnän mukaan verbin ${a[0]} yhteydessä ”${a[1]}”-ilmaus on ${a[3] ? `muodossa ${a[3]} + ${CASE_NAME_FI[a[2]!] ?? a[2]}` : (CASE_IN_FI[a[2]!] ?? a[2])}.`
        : `Verbin ${a[0]} objekti on muodossa ${a[3]} + ${CASE_NAME_FI[a[2]!] ?? a[2]}, kuten sanakirjan merkinnässä sanotaan.`,
    en: (a: string[]) =>
      a[1]
        ? `With the verb ${a[0]}, “${a[1]}” + noun is ${a[3] ? `${a[3]} + the ${CASE_IN_EN[a[2]!] ?? a[2]}` : `in the ${CASE_IN_EN[a[2]!] ?? a[2]}`}, as its dictionary entry says.`
        : `The verb ${a[0]} takes its object as ${a[3]} + the ${CASE_IN_EN[a[2]!] ?? a[2]}, as its dictionary entry says.`,
  },
  frameGenitive: {
    args: ['word', 'case'],
    fi: (a: string[]) =>
      `Verbin ${a[0]} täydennys on ${CASE_IN_FI[a[1]!] ?? a[1]} tai, kun se on yksikössä suoraan verbin edellä, genetiivissä, kuten tässä. Näin sanakirjan merkinnässä sanotaan.`,
    en: (a: string[]) =>
      `The verb ${a[0]} takes the ${CASE_IN_EN[a[1]!] ?? a[1]}, or the genitive for a singular word right before the verb, as here (its dictionary entry).`,
  },
  frameReflexive: {
    args: ['word', 'en'],
    fi: (a: string[]) => `Verbiin ${a[0]} sisältyy jo ”itsensä”, joten englannin ”${a[1]}” jää ilman omaa sanaa.`,
    en: (a: string[]) => `The verb ${a[0]} already includes “oneself”, so “${a[1]}” has no word of its own.`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
